import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS } from 'src/app/shared/constants/language-constants';
import { CommonService } from 'src/app/shared/utils/common.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-completed',
  templateUrl: './completed.component.html',
  styleUrls: ['./completed.component.scss'],
})
export class CompletedComponent implements OnInit, AfterViewChecked {
  formGroupUserDetail!: FormGroup;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() formReset = new EventEmitter();
  @Input() isAccessComplete = false;
  @Input() headerTitleKey = 'ACCESS_COMPLETED_ACCESS_UPDATED';
  @Input()  flowType!: string;
  @Output() flowTypeChange = new EventEmitter<string>();
  @ViewChild('userAdded') userAdded!: ElementRef;

  readonly LANG_CONST = LANGUAGE_CONSTANTS;
  readonly CONSTANTS = CONSTANTS;

  constructor(
    private rootFormGroup: FormGroupDirective,
    public commonService: CommonService,
    private localizationService: LocalizationService
  ) {}

  /**
   * @description angular hook
   * get formgroup detail to show user name
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.formGroupUserDetail = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(result: boolean = false): void {
    if (result) this.dialogRef?.close(true);
    else this.dialogRef?.close();
  }

  ngAfterViewChecked(): void {
    if (this.userAdded && this.userAdded.nativeElement) {
      this.userAdded.nativeElement.focus();
    }
  }

  navigateToUserAccess() {
    this.stepperChange.emit((this.stepper = 2));
  }

  /**
   * @description navigate main button form 1 step
   * @returns void
   */
  addAnotherUser(): void {
    this.formReset.emit();
  }
}
